import { render, staticRenderFns } from "./wait-add-product-select.vue?vue&type=template&id=2e56bfe5&scoped=true&"
import script from "./wait-add-product-select.vue?vue&type=script&lang=js&"
export * from "./wait-add-product-select.vue?vue&type=script&lang=js&"
import style0 from "./wait-add-product-select.vue?vue&type=style&index=0&id=2e56bfe5&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e56bfe5",
  null
  
)

export default component.exports